// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RPCResponseId
 */
export interface RPCResponseId {
}

/**
 * Check if a given object implements the RPCResponseId interface.
 */
export function instanceOfRPCResponseId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RPCResponseIdFromJSON(json: any): RPCResponseId {
    return RPCResponseIdFromJSONTyped(json, false);
}

export function RPCResponseIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): RPCResponseId {
    return json;
}

export function RPCResponseIdToJSON(value?: RPCResponseId | null): any {
    return value;
}

